/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import Link from 'gatsby-link';

import Headroom from 'react-headroom';

const NavBar = () => {
  return (
    <Headroom disableInlineStyles={true}>
      <nav
        className="navbar is-black"
        aria-label="main navigation"
        data-target="navMenu"
      >
        <div className="container">
          <div className="navbar-brand">
            <Link
              to="/"
              className="navbar-item is-size-3-desktop is-size-4-tablet is-size-5-mobile"
            >
              <span className="logo-first is-italic has-text-light-grey">
                borrowed
              </span>
              <span className="logo-second">verse</span>
            </Link>
            <button
              className="button navbar-burger is-primary"
              data-target="navMenu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
          <div className="navbar-menu" id="navMenu">
            <div className="navbar-end is-size-7">
              <div className="field is-grouped">
                <Link className="navbar-item" to="/about">
                  About
                </Link>
                <Link className="navbar-item" to="/album">
                  Album
                </Link>
                <Link className="navbar-item danger-highlight" to="/darkmofo">
                  Dark Mofo 2018
                </Link>
                <Link className="navbar-item" to="/contact">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </Headroom>
  );
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/components/NavBar/index.js